"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarIcon = void 0;
var react_1 = __importStar(require("react"));
var uniqueId_1 = __importDefault(require("lodash/uniqueId"));
var StarIcon_module_css_1 = __importDefault(require("./StarIcon.module.css"));
var build_svg_icon_1 = require("./build-svg-icon");
exports.StarIcon = (0, build_svg_icon_1.buildSvgIcon)(function (props) {
    /* To create the star percentage we need to create a linearGradient mask
     if the mask id collides with another id, the browser defaults to a no-op
     and doesn't render the star, thus we need to ensure each maskId is unique
    */
    var _a = __read((0, react_1.useState)((0, uniqueId_1.default)('star-icon-')), 1), randomId = _a[0];
    var starProps = props ? props : {};
    var fillPercentage = typeof starProps.fillPercentage === 'number'
        ? starProps.fillPercentage
        : 100;
    var stopColorClassName = starProps.variation === 'secondary'
        ? StarIcon_module_css_1.default.stopColorSecondary
        : StarIcon_module_css_1.default.stopColor;
    var offsetPercentage = Math.round(fillPercentage * 100);
    var fillClassName;
    if (fillPercentage === 100) {
        fillClassName =
            starProps.variation === 'secondary'
                ? StarIcon_module_css_1.default.fillColorSecondary
                : StarIcon_module_css_1.default.fillColor;
    }
    else if (fillPercentage === 0) {
        fillClassName = StarIcon_module_css_1.default.emptyColor;
    }
    var isValidPercentage = fillPercentage > 0 && fillPercentage < 100;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isValidPercentage && (react_1.default.createElement("defs", null,
            react_1.default.createElement("linearGradient", { id: "offset-".concat(randomId) },
                react_1.default.createElement("stop", { offset: "0%", className: stopColorClassName }),
                react_1.default.createElement("stop", { offset: "".concat(offsetPercentage, "%"), className: stopColorClassName }),
                react_1.default.createElement("stop", { offset: "".concat(offsetPercentage, "%"), className: StarIcon_module_css_1.default.stopColorEmpty }),
                react_1.default.createElement("stop", { offset: "100%", className: StarIcon_module_css_1.default.stopColorEmpty })))),
        react_1.default.createElement("path", { className: fillClassName, fill: fillClassName === undefined ? "url(#offset-".concat(randomId, ")") : undefined, fillRule: "evenodd", clipRule: "evenodd", d: "M11.2466 35.1123C10.0601 35.7266 8.67346 34.7345 8.90005 33.4334L10.5718 23.8347L3.49016 17.0368C2.53029 16.1154 3.05996 14.5101 4.38646 14.3203L14.1731 12.9198L18.5498 4.18662C19.143 3.0029 20.857 3.0029 21.4503 4.18662L25.8269 12.9198L35.6135 14.3203C36.94 14.5101 37.4697 16.1154 36.5098 17.0368L29.4282 23.8347L31.0999 33.4334C31.3265 34.7345 29.9399 35.7266 28.7534 35.1123L20 30.5804L11.2466 35.1123Z" })));
}, 'StarIcon', { viewBox: '0 0 40 40' });
exports.default = exports.StarIcon;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/icons/StarIcon.js
// module id = 3568
// module chunks = 25